import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class DocumentsDataPaths {
  static documentData = new EnhancedPath('/document-data');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: DocumentsDataPaths.documentData.path,
      component: lazyWithRetry(() => import('app/pages/documents/document-data')),
      pageCode: PAGE_CODES.DOCUMENT_EXTRACTION,
    },
  ],
};

export default routesConfig;
